import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AccountInitDataProjectsQuery } from 'api/account';
import { CompanyId, User } from 'api/models';
import { Field as ApiField } from 'api/tasks';
import { CompaniesStore } from 'stores/companies';
import { MembershipsStore } from 'stores/memberships';
import { TeamsStore } from 'stores/teams';
import { UsersStore } from 'stores/users';
import { Field, FieldsStore } from './store';

export const slice = createSlice({
  name: '@@FIELDS',
  initialState: FieldsStore.empty(),
  reducers: {
    load: (state: FieldsStore) => FieldsStore.load()(state),
    putAll: (
      state: FieldsStore,
      { payload: fields }: PayloadAction<ApiField[]>,
    ) => FieldsStore.putAll(fields)(state),
    add: (state: FieldsStore, { payload: field }: PayloadAction<ApiField>) =>
      FieldsStore.add(field)(state),
    remove: (state: FieldsStore, { payload: fieldId }: PayloadAction<number>) =>
      FieldsStore.remove(fieldId)(state),
    refresh: (
      state: FieldsStore,
      {
        payload: args,
      }: PayloadAction<
        [
          UsersStore,
          TeamsStore,
          MembershipsStore,
          CompaniesStore,
          CompanyId,
          User,
          number | undefined,
          AccountInitDataProjectsQuery | undefined,
          (fields: (ApiField | Field)[]) => (ApiField | Field)[],
          boolean,
        ]
      >,
    ) => FieldsStore.refresh(...args)(state),
  },
});
